<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :placeholder="placeholder"
      :style="width ? `width: ${width}` : ''"
      :multiple="multiple"
      filterable
      :disabled="disabled"
      :clearable="clearable"
      :size="size"
      @change="handleChange"
    >
      <v-avatar-option :value="listBackUp" id-key="open_kfid" name-key="name" uni-key="CustomerAvatarOption"/>
    </el-select>
  </div>
</template>

<script>
import { getCustomers } from "@/api/store";

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    storeId: [Number, String],
    width: String,
    remote: Boolean,
    clearable: Boolean,
    multiple: Boolean,
    placeholder: {
      type: String,
      default: '请选择客服号',
    },
    label: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    disabledIds: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  data: () => ({
    valueBackup: '',
    listBackUp: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await getCustomers();
      if (isError) return;

      this.listBackUp = data || [];
    },
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = this.value || '';
    }

    if (this.list.length) return this.listBackUp = this.list;
    this.getList();
  },
};
</script>
